var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.parsedRows),function(row,index){return _c('RichText',{key:index,staticClass:"py-2.5 pl-2.5 highlight__item",class:{ 'bg-EXPONDO-grey-5 pl-10' : index % 2 == 0 },attrs:{"rich-text":row.richText}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }